import type { FC, ReactElement } from "react"

import { Button, ETypographyAlignment, ETypographyColor, ETypographySize, Typography } from "@/3514/components"
import { withDynamicHeightGuard } from "@/3514/guards"
import { EModalId, type IModal, type TModalDispatcher, useModalDispatcher, useModalSelector } from "@/3514/store/modal"
import { withPressHandler } from "@/3514/utils"
import { type IUseTranslation, useTranslation } from "@/hooks"

import classes from "./attendance.modal.styles"
import type { TAttendanceEarlyModalProps as TModalProps } from "./attendance.modal.ui.types"

const AttendanceEarlySessionModalBody: FC = (): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    const modalDispatcher: TModalDispatcher = useModalDispatcher()

    const { props: modalProps }: IModal<TModalProps> = useModalSelector<TModalProps>(EModalId.AttendanceEarly)

    function handleSubmit(): void {
        modalDispatcher.hideModal(EModalId.AttendanceEarly)
    }

    return (
        <div className={classes.earlyAttendance.container()}>
            <div className={classes.earlyAttendance.middleWrapper()}>
                <Typography
                    text={t("modals.earlyAttendance.description", {
                        amount: modalProps.advanceTimeInHours
                    })}
                    alignment={ETypographyAlignment.Center}
                />

                <Typography
                    text={t("modals.earlyAttendance.hint")}
                    alignment={ETypographyAlignment.Center}
                    size={ETypographySize.Tiny}
                    color={ETypographyColor.Gray23}
                    isItalic
                />
            </div>

            <Button onClick={withPressHandler(handleSubmit)} onKeyDown={withPressHandler(handleSubmit)} minWidth="80px">
                {t("common.gotIt")}
            </Button>
        </div>
    )
}

AttendanceEarlySessionModalBody.displayName = "AttendanceEarlySessionModalBody"

export default withDynamicHeightGuard(AttendanceEarlySessionModalBody)
